export {
  DEFAULT_STEPS_PER_SECOND,
  LifeSimulator,
  type WorldPoint,
} from "./app/simulator";
export { NaiveLifeEngine } from "./engine/naive-engine";
export { GameOfLifeElement } from "./ui/game-of-life-element";

import { GameOfLifeElement } from "./ui/game-of-life-element";

customElements.define("game-of-life", GameOfLifeElement);
